import state from './moduleInvestorKycStatusState.js'
import mutations from './moduleInvestorKycStatusMutations.js'
import actions from './moduleInvestorKycStatusActions.js'
import getters from './moduleInvestorKycStatusGetters.js'

export default {
  isRegistered: false,
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
